import consolaModule from 'consola'

import { isDevMode, isTestMode } from '~/utils/env'
export const consola = consolaModule.create({
  level: (isDevMode() || isTestMode()) ? 4 : 0,
  // level: 4,
})
